import React from 'react';
// import MaskedInput from 'react-maskedinput';
import MaskedInput from "react-text-mask";

export default function PassportNumberInput(props) {
  const mask = '1'.repeat(6);

  return <MaskedInput 
  mask={ [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/] }
  placeholder="" {...props} 
  />;
}
